import { NavLink } from 'react-router-dom';

import { cn } from '../../lib/cn';
import styles from './bot.module.css';

const TABS: { to: string; label: string }[] = [
  { to: '/bot/conversations', label: 'שיחות' },
  { to: '/bot/analytics', label: 'אנליטיקה' },
  { to: '/bot/blocked', label: 'חסומים' },
  { to: '/bot/templates', label: 'תבניות' },
  { to: '/bot/scoring', label: 'דירוג' },
];

export function BotSubNav() {
  return (
    <nav className={styles.subnav} aria-label="ניווט באזור הבוט">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) => cn(styles.subnavTab, isActive && styles.subnavTabActive)}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
